import React from 'react';

import NewInternalUserForm from '@views/Admin/Management/Users/Create/NewInternalUserForm';
import OrgSettingLayout from '@views/Organization/OrgSettingManagementLayout';

export default function UserManagementAddUserPage(
  props: PagePropsWithBreadcrumbs
) {
  return (
    <OrgSettingLayout pageProps={props}>
      {({ account_id }) => <NewInternalUserForm account_id={account_id} />}
    </OrgSettingLayout>
  );
}
